import { TCheckDuplicateEmployeeFieldsOutputDto } from "@/api/services/main/employee/dtos/check-duplicate-employee-fields.dto";
import { Linkable } from "@/components/elements/Linkable";
import { Modal } from "@/components/elements/Modal";
import { TEmployeeForm } from "@/features/employee/types/employeeForm";
import { AppRoutes } from "@/routes/config";
import { FCC } from "@/types/common";
import { toNumber } from "@/utils/number";
import { getFullName } from "@/utils/string";
import { getDynamicRoute } from "@/utils/url";
import { Stack, Typography } from "@mui/material";
import { useFormContext, useWatch } from "react-hook-form";

type TCheckDuplicateEmployeeFieldsModalProps = {
  existingDuplicateEmployeeFields?: TCheckDuplicateEmployeeFieldsOutputDto[];
  onClose: () => void;
};

export const CheckDuplicateEmployeeFieldsModal: FCC<TCheckDuplicateEmployeeFieldsModalProps> = ({ existingDuplicateEmployeeFields, onClose }) => {
  const { control } = useFormContext<TEmployeeForm>();

  const residenceCodeWatchField = useWatch({ control, name: "residenceCode" });
  const managementNumberWatchField = useWatch({ control, name: "managementNumber" });
  const passportCodeWatchField = useWatch({ control, name: "passportCode" });

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal
      isOpen={!!existingDuplicateEmployeeFields}
      title="エラー"
      onClose={handleClose}
      labelClose="閉じる"
      width={600}
      enableCloseIcon={false}
      hiddenOkBtn
      justifyBtnAction="center"
    >
      <Stack sx={{ display: "block" }} my={2}>
        {existingDuplicateEmployeeFields &&
          existingDuplicateEmployeeFields.map((employee, index) => {
            const duplicateFields: { label: string; value: string }[] = [];
            if (employee.managementNumber && managementNumberWatchField && employee.managementNumber === managementNumberWatchField) {
              duplicateFields.push({ label: "管理番号", value: employee.managementNumber });
            }
            if (passportCodeWatchField && employee.passportCode && employee.passportCode === passportCodeWatchField) {
              duplicateFields.push({ label: "旅券番号", value: employee.passportCode });
            }
            if (residenceCodeWatchField && employee.residenceCode && employee.residenceCode === residenceCodeWatchField) {
              duplicateFields.push({ label: "在留カード番号", value: employee.residenceCode });
            }

            const firstDuplicateFieldElmId = [
              { label: "管理番号", elmId: "management_number_input" },
              { label: "旅券番号", elmId: "passport_code_input" },
              { label: "在留カード番号", elmId: "residence_code_input" },
            ].find((item) => item.label === duplicateFields.at(0)?.label)?.elmId;
            return (
              <Typography component="p" variant="subtitle1" key={index}>
                {duplicateFields.map((item) => `${item.label} （${item.value}）`).join("、")}が
                <Linkable
                  sx={{ display: "inline", textDecoration: "underline" }}
                  target="_blank"
                  href={`${getDynamicRoute(AppRoutes.employeeEdit, { id: toNumber(employee?.id) })}#${firstDuplicateFieldElmId}`}
                >
                  {getFullName({ lastName: employee?.lastName, middleName: employee?.middleName, firstName: employee?.firstName || "" })}
                </Linkable>
                と重複しています。
              </Typography>
            );
          })}
      </Stack>
    </Modal>
  );
};
